export const DotSymbol = "•";
export const Rupee = "₹";
